import { Intersection, Mesh } from 'three';

import { isDefined } from '../../../../../utils/variables';
import { calculateArea } from '../../../../utilities/math-helpers';
import { AttributeData, AttributeId } from '../../skymap-extras';
import { DesignNode } from '../design-node';
import { PointId } from './point-node';

export type FaceId = number & { __type: 'FaceId' };

export type FaceNode = {
  id: FaceId;
  values: [PointId, PointId, PointId];
  attributes: Map<AttributeId, AttributeData>;
  area: number;
  planarArea: number;
};

export function findFaceIdFromIntersection(
  node: DesignNode,
  intersection?: Intersection,
): FaceId | undefined {
  return intersection?.object instanceof Mesh && isDefined(intersection.faceIndex)
    ? node.getFaceByIndex(intersection.faceIndex)?.id
    : undefined;
}

export function recalculateFaceMetadata(node: DesignNode, ids: FaceId[]) {
  for (const id of ids) {
    const face = node.getFaceById(id);
    const vertices = node.getVerticesByFaceId(id, 'local').flatMap((x) => x.toArray());
    face.area = calculateArea(vertices, [0, 1, 2], false);
    face.planarArea = calculateArea(vertices, [0, 1, 2], true);
  }
}
